// @ts-nocheck
/* eslint-disable */
import { _ } from "~/i18n";
import { setMapset } from "~/state/map/state";
import { store } from "~/state/store";

Mapy.SuggestMap = (function() {
	const MAPS = {
		car: {
			text: _("suggestMap.car"),
			src: "/img/suggest-map/traffic.png",
			srcset: "/img/suggest-map/traffic.png, /img/suggest-map/traffic2x.png 2x",
			action: function() {
				store.dispatch(setMapset({ mapset: "dopravni" }));
			},
		},
		bike: {
			text: _("suggestMap.bike"),
			src: "/img/suggest-map/turist.png",
			srcset: "/img/suggest-map/turist.png, /img/suggest-map/turist2x.png 2x",
			action: function() {
				store.dispatch(setMapset({ mapset: "turisticka" }));
			},
		},
		turist: {
			text: _("suggestMap.turist"),
			src: "/img/suggest-map/turist.png",
			srcset: "/img/suggest-map/turist.png, /img/suggest-map/turist2x.png 2x",
			action: function() {
				store.dispatch(setMapset({ mapset: "turisticka" }));
			},
		},
		ski: {
			text: _("suggestMap.ski"),
			src: "/img/suggest-map/winter.png",
			srcset: "/img/suggest-map/winter.png, /img/suggest-map/winter2x.png 2x",
			action: function() {
				store.dispatch(setMapset({ mapset: "zimni" }));
			},
		},
	};

	class SuggestMap {
		constructor(options) {
			this._map = options.map || "car";
			this._onDecline = options.onDecline || function() {};
			this._onAccept = options.onAccept || function() {};
			this._mapToLog = options.mapToLog || {};
			this._container = Mapy.Util.node("div", { className: "suggest-map hidden" });

			// sestavime levy pruh s textem a tlacitky
			const leftRow = Mapy.Util.node("div", { className: "left-row" });
			leftRow.appendChild(Mapy.Util.node("p", { innerHTML: MAPS[this._map].text }));

			// tlacitka
			this._activateButton = Mapy.Util.node("button", { className: "button", type: "button", innerHTML: _("suggestMap.activate") });
			leftRow.appendChild(this._activateButton);
			this._closeButton = Mapy.Util.node("button", { className: "link", type: "button", innerHTML: _("promo.notnow") });
			leftRow.appendChild(this._closeButton);

			// pripneme do rodice
			this._container.appendChild(leftRow);

			// pokud mame obrazek, pridame ho
			const imgCont = Mapy.Util.node("div", { className: "img-cont" });
			imgCont.appendChild(Mapy.Util.node("img", { src: MAPS[this._map].src, srcset: MAPS[this._map].srcset }));
			this._container.appendChild(imgCont);
		}

		get map() {
			return this._map;
		}

		open() {
			document.body.appendChild(this._container);
			// eslint-disable-next-line no-unused-expressions
			this._container.clientHeight;
			this._container.classList.remove("hidden");
			document.body.addEventListener("click", this, false);
		}

		close() {
			this._container.classList.add("hidden");
			document.body.removeEventListener("click", this, false);
			setTimeout(() => {
				this._container.remove();
			}, 100);
		}

		handleEvent(event) {
			if (!this._container.contains(event.target)) {
				Mapy.getComponent("logger").log("map_banner_no_action", { type: this._mapToLog[this._map] });
				this.close();
				this._onDecline();
			} else if (event.target === this._closeButton) {
				Mapy.getComponent("logger").log("map_banner_close", { type: this._mapToLog[this._map] });
				this.close();
				this._onDecline();
			} else if (event.target === this._activateButton) {
				Mapy.getComponent("logger").log("map_banner_click", { type: this._mapToLog[this._map] });
				MAPS[this._map].action();
				this.close();
				this._onAccept();
			}
		}
	};

	return SuggestMap;
})();
